import React from 'react';

import { TrackBingEventContext } from 'common/containers/BingContainer';
import { TrackCannylyticsEventContext } from 'common/containers/CannylyticsContainer';
import { TrackHubSpotEventContext } from 'common/containers/HubSpotContainer';
import { TrackIntercomEventContext } from 'common/containers/IntercomContainer';
import { TrackLinkedInEventContext } from 'common/containers/LinkedInContainer';
import { TrackMixpanelEventContext } from 'common/containers/MixpanelContainer';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import GoogleAnalytics from 'common/ga/GoogleAnalytics';
import snakeCase from 'common/util/snakeCase';
import withContexts from 'common/util/withContexts';

export const TrackEventContext = React.createContext();

const CannyEventsToRedditEvents = {
  'ViewedContent(30secs)': 'ViewContent',
  DemoRequest: 'Lead',
  RegisteredCompany: 'SignUp',
};

const trackFacebookEvent = (name, data) => {
  if (typeof window.fbq !== 'undefined') {
    window.fbq('trackCustom', name, data);
  }
};

const trackRedditEvent = (name, data) => {
  if (typeof window.rdt !== 'undefined') {
    window.rdt('track', 'Custom', {
      customEventName: name,
      ...data,
    });

    const strippedName = name.replace(/\s/g, '');

    // Reddit suggests we send a non-custom event for some of our custom events
    if (CannyEventsToRedditEvents[strippedName]) {
      window.rdt('track', CannyEventsToRedditEvents[strippedName]);
    }
  }
};

const trackGoogleAnalyticsEvent = (name, data) => {
  const snakeCasedName = snakeCase(name);
  GoogleAnalytics.trackEvent('cannyTracker', snakeCasedName, {
    category: 'Canny Events',
    label: snakeCasedName,
  });
};

const EventContainer = ({
  children,
  trackBingEvent,
  trackCannylyticsEvent,
  trackHubSpotEvent,
  trackIntercomEvent,
  trackLinkedInEvent,
  trackMixpanelEvent,
  ...props
}) => {
  const trackEvent = (name, data) => {
    if (__DEV__ || __SSR_TEST_RUNNER__) {
      return;
    }

    trackCannylyticsEvent(name);
    trackGoogleAnalyticsEvent(name, data);
    trackHubSpotEvent(name, data);
    trackIntercomEvent(name, data);
    trackMixpanelEvent(name, data);

    // Advertiser trackers
    trackBingEvent(name, data);
    trackLinkedInEvent(name, data);
    trackFacebookEvent(name, data);
    trackRedditEvent(name, data);
  };

  return (
    <TrackEventContext.Provider value={trackEvent}>
      {cloneElementWithProps(children, props)}
    </TrackEventContext.Provider>
  );
};

export default withContexts(
  {
    trackBingEvent: TrackBingEventContext,
    trackCannylyticsEvent: TrackCannylyticsEventContext,
    trackHubSpotEvent: TrackHubSpotEventContext,
    trackIntercomEvent: TrackIntercomEventContext,
    trackLinkedInEvent: TrackLinkedInEventContext,
    trackMixpanelEvent: TrackMixpanelEventContext,
  },
  { forwardRef: true }
)(EventContainer);
